
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqA3oKmmhe5yKWSLCSFGqAI6Pig_45nkvHQhLZiFI9DHtIsMeta } from "/codebuild/output/src1223967413/src/src/pages/faq.vue?macro=true";
import { default as menuUBUV3LuexBEq7lY5xR3Zol6jhfn2sDe4_45m9k0qkdQVYMeta } from "/codebuild/output/src1223967413/src/src/pages/menu.vue?macro=true";
import { default as indexGfVFxfGGQTyEWV7Gmv8ChkS44Zl6Kic1y7NlJTGbtaUMeta } from "/codebuild/output/src1223967413/src/src/pages/index.vue?macro=true";
import { default as contactoQ_45ZnE7A8m973POWuAaz_xmvOE4rW8ZR3RLoYKkDS68Meta } from "/codebuild/output/src1223967413/src/src/pages/contact.vue?macro=true";
import { default as tutorial_xCcz6a7f_FRsYk3LJ7dcI2mqAOsgE6ZDGfis807FscMeta } from "/codebuild/output/src1223967413/src/src/pages/tutorial.vue?macro=true";
import { default as agreementeOaFdTf4dm0N8Tura1NoTVU6sOHgg8DQXF3Yot7qbYgMeta } from "/codebuild/output/src1223967413/src/src/pages/agreement.vue?macro=true";
import { default as about_45pass10edayXqCCcYeP3BNnd8w_IkYaOF48Ug070k8BjXZfEMeta } from "/codebuild/output/src1223967413/src/src/pages/about-pass.vue?macro=true";
import { default as indexsnII7hSCRC39_45_45nESEzZjA3_45KuxgTdldbo86XICaxjwMeta } from "/codebuild/output/src1223967413/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93IyoPSzi8kHz76qjuHvvLO7_452roE7HiFK3JPGw9vuRVEMeta } from "/codebuild/output/src1223967413/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceAKnzjtKEc3Bt1kU2T9TsLyNVXiBI7vessraLEKBDhbYMeta } from "/codebuild/output/src1223967413/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93MbOt_45ifdLvlwEbzt5_eLXdGU3eqhlhwPBhoPyYyzKN0Meta } from "/codebuild/output/src1223967413/src/src/pages/notice/[id].vue?macro=true";
import { default as indexFRrA8ADyGCRsmjfyDpyz2v80qt01zJAU12P7Nj4r9wAMeta } from "/codebuild/output/src1223967413/src/src/pages/coupon/index.vue?macro=true";
import { default as indexSQEHNvaN0xx3uY_r_45lLDbafHLvZDEJJS5mLMhGUiZ5kMeta } from "/codebuild/output/src1223967413/src/src/pages/mypage/index.vue?macro=true";
import { default as index7Dc963MhxIJhYRyWP8LiU1MRS8fTYoF6Zgv_45N1qh48QMeta } from "/codebuild/output/src1223967413/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93Sf3EJgMSLEXbdWg46gry2xN1ySdKw9pq7cO_45mDRMe9IMeta } from "/codebuild/output/src1223967413/src/src/pages/parking/[id].vue?macro=true";
import { default as index09oS8sng9Nb5U8sBIAqnragB9y8Ks1YuYm_45zQgckYgQMeta } from "/codebuild/output/src1223967413/src/src/pages/history/index.vue?macro=true";
import { default as indexeLU5f6USRtHaXVDjqU_45J_9YQZ848SLKtEpjcGZ5M61IMeta } from "/codebuild/output/src1223967413/src/src/pages/monthly/index.vue?macro=true";
import { default as index20D9IfMCa9jMY_4560otxiz9WlTFmJng_453M9TOmRxdns0Meta } from "/codebuild/output/src1223967413/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexsRPvXVG40SHF7DEP4W9hWTInmhfRGJ8hcVdIOefacXkMeta } from "/codebuild/output/src1223967413/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavi3ZBKY11F5CAchmg_dWWyyezPYQnS_6SC9FXbt1tLO_45MMeta } from "/codebuild/output/src1223967413/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edith7XftB2decicjAFb2YDV6QL5Dv567f_45b8CfGSTlJ9nEMeta } from "/codebuild/output/src1223967413/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementa_MO5ZsQjxSvPQIGwxTcvDT0o8IiutnFdm24TMFolKoMeta } from "/codebuild/output/src1223967413/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexC5XvU_45Jt93pIQqZd0Odtn63tQb46B9ZyGhZ6CLLqNRoMeta } from "/codebuild/output/src1223967413/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dBzrP9C_0DYdpB_45bAluiQy2yUxjU62SXCH1yL_bBXQxAMeta } from "/codebuild/output/src1223967413/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm7JSKmNciCZscMB_45hDaSD9QGQmCPRWpuQotvKEljbWa8Meta } from "/codebuild/output/src1223967413/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as index0bwfwRhq__45WstYZBdCqgCTRrnZhHtG_45SlDiTvxocriEMeta } from "/codebuild/output/src1223967413/src/src/pages/card/create/index.vue?macro=true";
import { default as indexwOrhKBQyb7OJe7ZzvLwFAthIdJ3AAxDI8op9Io9S2CQMeta } from "/codebuild/output/src1223967413/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm_IxSeUaXRbHRrHFkwxq0lFRsx3ij3Sj5CX23iuPliVAMeta } from "/codebuild/output/src1223967413/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmFz19l6e8JDAfUAYJnxz5aOwmg6i8LNbyUOS_MXxpLmAMeta } from "/codebuild/output/src1223967413/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completecHXpJVNuYsVDQy1jNoI_457ewvqh3jClqYieNWpNE4GAQMeta } from "/codebuild/output/src1223967413/src/src/pages/membership/complete.vue?macro=true";
import { default as register6g4_pToI_45QVgk5_5q4ae0FXQ3Ul2jYUz_sybaaH_45QT8Meta } from "/codebuild/output/src1223967413/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93xXP_PrpNyMWmjoKn3H6z9vaBPg6bcYPIRegQe_4EhE0Meta } from "/codebuild/output/src1223967413/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirm10JyOZuENZDSnIe7Wv2V8MheADqZqSc7EUoz0_86nKgMeta } from "/codebuild/output/src1223967413/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93URvhXE693R9YwzlMCVhA0uv2lnefj8a5wmQqLl_45T_7YMeta } from "/codebuild/output/src1223967413/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexVFIfgO6m7CRehuMWsSM_ZxaNAR7pA3aQJISFRayxSsgMeta } from "/codebuild/output/src1223967413/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeBDWQvHIe6jjZMW5ObUWxqOIwAFBCowG_YYwmm2dKOjQMeta } from "/codebuild/output/src1223967413/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codejuafSuhZue_45YdSJSso1XZl_45VbHxDvnD4kxCIloAprecMeta } from "/codebuild/output/src1223967413/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completej5yskwDvqhwCnYCkORhznb8lswel4V2d_458tCE6P7fpYMeta } from "/codebuild/output/src1223967413/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerU2wo3QQDtBCB5M9NBhtb5RkaLNuLHuaWebAx8YcsSCUMeta } from "/codebuild/output/src1223967413/src/src/pages/contact-form/register.vue?macro=true";
import { default as completea6EKZrmM_454hWM2etj_45ignh8qUlLq5JYaNzX8Svh6z3oMeta } from "/codebuild/output/src1223967413/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as index_45S7Nu_0f6_45Dz1ayA0r7Qj9fW1vuDr_Fd3RQcDwUrKLAMeta } from "/codebuild/output/src1223967413/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmtmnPfVdgPaig2Rd9AO3xoIAJVrHAfmklh_jJjxUk5eUMeta } from "/codebuild/output/src1223967413/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completem4nDKo0qsBUDxw3KISCime5XY80lLrtaCyve5KPiJmEMeta } from "/codebuild/output/src1223967413/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexGYz0agpYUglBQAXKyRbDHze4mGAs0fxtpMtLAYkkIRYMeta } from "/codebuild/output/src1223967413/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93Tme10Dn0_45N9PlzeMzXV1D6j_45AK71XJ55sgePdXLUXloMeta } from "/codebuild/output/src1223967413/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeq3UFiuMM3fI6jP1MIVTvsdRbRblHXvuUdyfBvMHlChUMeta } from "/codebuild/output/src1223967413/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasxU_r2yPZtWsrpYtHZfMs8mWCESTMXmx6gMH3YQIDSMsMeta } from "/codebuild/output/src1223967413/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleeKzOZZGTm71AGCqIycOl5PTEdCqz4IvQGDTJMKyqo_0Meta } from "/codebuild/output/src1223967413/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailbF41wB5WLZRNylYHFz0_45mluCO3r6FNj6aQ0qMjiFhYsMeta } from "/codebuild/output/src1223967413/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmr4x1QKdUs8bm7k_45OxCt7TSAafTxscY7VaemB5RNM62EMeta } from "/codebuild/output/src1223967413/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentzHvIXtHR9h2n58AGkCVQRAceFyAtN8YrdrErnalXgacMeta } from "/codebuild/output/src1223967413/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmcLz1vNQik7d5j9hYIwc_45p_bNpeJRQwwqS2lcgyySXTkMeta } from "/codebuild/output/src1223967413/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateNkGdq3ghuWUOmkowYOoEm6B8S9rer_3jpYdRL1svkmQMeta } from "/codebuild/output/src1223967413/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeI5ILcEwlwjR6QtveoR_UZfxNXuFmTiU_45Mo8ow_45eP_C4Meta } from "/codebuild/output/src1223967413/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codebsykzza895aFrpzIWq10xhc3_T_R_d2LTGPtVsLpQd0Meta } from "/codebuild/output/src1223967413/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordfwx8GRn8r2hm9eEBlHORkybdqul8hHO0vXY6TjNzBTEMeta } from "/codebuild/output/src1223967413/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliassRQpFFCR9kxT9XPrUUmoCRIjJ1xjZX9QrHIH53JYTywMeta } from "/codebuild/output/src1223967413/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register34_45kDknd47rFnflYhHroN5WQMwK06zBQFwURrgUD7GoMeta } from "/codebuild/output/src1223967413/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codetXuZRRV5bp23Ul3z7LBmWaBCxkapTrQ_45Z5cMUTYBFHAMeta } from "/codebuild/output/src1223967413/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexJGyWYZZR41EqAmSOLEmhxelNNQtJiuZY0NWeAigYCykMeta } from "/codebuild/output/src1223967413/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexzfk_45eX3iixDdFINY3Gt_45ANoBPiPOlBIGhwjvnF6wHRcMeta } from "/codebuild/output/src1223967413/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexc0r1BH8FfjAwtO86tswt9ik6nOxssENXiqBTZEJiWvMMeta } from "/codebuild/output/src1223967413/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexJSFqEEArUl06jscrCzq7MWKjeOxpltnN_45GSUajejKb4Meta } from "/codebuild/output/src1223967413/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateGVWBS_459ESmBdsgMh_455XSJfLwtAvlQUECDZoLKW7O824Meta } from "/codebuild/output/src1223967413/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completenacHLN9wi0EpT0H49qONT6LN_456oD3E_tir4venAwEo0Meta } from "/codebuild/output/src1223967413/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirm205kNSJOhgGfSW5dAEfg02DzuUcG_454Z_TYDFLBrJtKoMeta } from "/codebuild/output/src1223967413/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexLCMoFyW2I8Xw0OC_45YB_45VBHKqvYVJMslJFG5x_450knK4IMeta } from "/codebuild/output/src1223967413/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completet4oqJvozyX8W5N6r_45Fs1qAgWKxTk6eL06mT2OZWJVJ0Meta } from "/codebuild/output/src1223967413/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateMMAZdSaEz2jIEAwi7rKL8EBATG1uoJNPNmaBNOqPhs8Meta } from "/codebuild/output/src1223967413/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexhFDIB84xlUTnHYLYQa1abIMofmQ9KJzGjZDOO4b4CUIMeta } from "/codebuild/output/src1223967413/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexJjlWPUJ3V4SXBhF41NaGju7wJuqRubOLu7C6EjZkRzUMeta } from "/codebuild/output/src1223967413/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completez2tnHrigFr2PCT0mBrjlB5641sou2UiWwKRyjsOYtS0Meta } from "/codebuild/output/src1223967413/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexlIF6aPDa9a_xdJOp5SIYcDHUvZac4WHBnswjeEK35_45gMeta } from "/codebuild/output/src1223967413/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code6zzl6FXg3ose64IWC2SchB5UAHGsPUk_45EYOmVp9CIEQMeta } from "/codebuild/output/src1223967413/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexxwqojlEtSerPJJT6R1PWznQ9IEsEOXPwkDjdBOc_45TlQMeta } from "/codebuild/output/src1223967413/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as index6_BuQXKBUvfc1MEhZG6TFqNIqtBvQ7bJyFAGyNprIrIMeta } from "/codebuild/output/src1223967413/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexPEKqIr8DgISDHgPxznseqebByHriaLOUkFax5AF9HUcMeta } from "/codebuild/output/src1223967413/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update_lguKHnYwC2vnQ9uPkKt8mBZHZ_4521P9GPkSS3SukXbMMeta } from "/codebuild/output/src1223967413/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmz9AF0uQhpvCD1zZP9iPha_pEEFtS4a6rOASCO1I2LjoMeta } from "/codebuild/output/src1223967413/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuUBUV3LuexBEq7lY5xR3Zol6jhfn2sDe4_45m9k0qkdQVYMeta || {},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexGfVFxfGGQTyEWV7Gmv8ChkS44Zl6Kic1y7NlJTGbtaUMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src1223967413/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexFRrA8ADyGCRsmjfyDpyz2v80qt01zJAU12P7Nj4r9wAMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1223967413/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index09oS8sng9Nb5U8sBIAqnragB9y8Ks1YuYm_45zQgckYgQMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1223967413/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: index20D9IfMCa9jMY_4560otxiz9WlTFmJng_453M9TOmRxdns0Meta || {},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexsRPvXVG40SHF7DEP4W9hWTInmhfRGJ8hcVdIOefacXkMeta || {},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: index0bwfwRhq__45WstYZBdCqgCTRrnZhHtG_45SlDiTvxocriEMeta || {},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm_IxSeUaXRbHRrHFkwxq0lFRsx3ij3Sj5CX23iuPliVAMeta || {},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmFz19l6e8JDAfUAYJnxz5aOwmg6i8LNbyUOS_MXxpLmAMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1223967413/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completecHXpJVNuYsVDQy1jNoI_457ewvqh3jClqYieNWpNE4GAQMeta || {},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: register6g4_pToI_45QVgk5_5q4ae0FXQ3Ul2jYUz_sybaaH_45QT8Meta || {},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirm10JyOZuENZDSnIe7Wv2V8MheADqZqSc7EUoz0_86nKgMeta || {},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeBDWQvHIe6jjZMW5ObUWxqOIwAFBCowG_YYwmm2dKOjQMeta || {},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codejuafSuhZue_45YdSJSso1XZl_45VbHxDvnD4kxCIloAprecMeta || {},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completej5yskwDvqhwCnYCkORhznb8lswel4V2d_458tCE6P7fpYMeta || {},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerU2wo3QQDtBCB5M9NBhtb5RkaLNuLHuaWebAx8YcsSCUMeta || {},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmtmnPfVdgPaig2Rd9AO3xoIAJVrHAfmklh_jJjxUk5eUMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completem4nDKo0qsBUDxw3KISCime5XY80lLrtaCyve5KPiJmEMeta || {},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexGYz0agpYUglBQAXKyRbDHze4mGAs0fxtpMtLAYkkIRYMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeq3UFiuMM3fI6jP1MIVTvsdRbRblHXvuUdyfBvMHlChUMeta || {},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleeKzOZZGTm71AGCqIycOl5PTEdCqz4IvQGDTJMKyqo_0Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailbF41wB5WLZRNylYHFz0_45mluCO3r6FNj6aQ0qMjiFhYsMeta || {},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmr4x1QKdUs8bm7k_45OxCt7TSAafTxscY7VaemB5RNM62EMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentzHvIXtHR9h2n58AGkCVQRAceFyAtN8YrdrErnalXgacMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmcLz1vNQik7d5j9hYIwc_45p_bNpeJRQwwqS2lcgyySXTkMeta || {},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeI5ILcEwlwjR6QtveoR_UZfxNXuFmTiU_45Mo8ow_45eP_C4Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codebsykzza895aFrpzIWq10xhc3_T_R_d2LTGPtVsLpQd0Meta || {},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordfwx8GRn8r2hm9eEBlHORkybdqul8hHO0vXY6TjNzBTEMeta || {},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register34_45kDknd47rFnflYhHroN5WQMwK06zBQFwURrgUD7GoMeta || {},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codetXuZRRV5bp23Ul3z7LBmWaBCxkapTrQ_45Z5cMUTYBFHAMeta || {},
    component: () => import("/codebuild/output/src1223967413/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1223967413/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]